var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _circle2, _rect7, _rect8, _rect9, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 190,
    viewBox: "0 0 493 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.414062,
    width: 106.643,
    height: 16,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.18359,
    y: 24.9141,
    width: 214,
    height: 47,
    rx: 7.5,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 246.658,
    cy: 53.7559,
    r: 18.6582,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 277.316,
    y: 0.414062,
    width: 106.643,
    height: 16,
    rx: 4,
    fill: "#F5F7F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 24.9141,
    width: 214,
    height: 47,
    rx: 7.5,
    stroke: "#F5F7F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 88.4141,
    width: 106.643,
    height: 16,
    rx: 4,
    fill: "#F5F7F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 112.914,
    width: 214,
    height: 47,
    rx: 7.5,
    stroke: "#F5F7F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.658,
    cy: 141.756,
    r: 18.6582,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 277.316,
    y: 88.4141,
    width: 106.643,
    height: 16,
    rx: 4,
    fill: "#F5F7F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 112.914,
    width: 214,
    height: 47,
    rx: 7.5,
    stroke: "#F5F7F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 176.914,
    width: 11.7246,
    height: 11.7246,
    rx: 2.5,
    stroke: "#F5F7F9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7246,
    y: 176.414,
    width: 122.725,
    height: 12.7246,
    rx: 3,
    fill: "#F5F7F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.1ca590a29b9c5a80b2ebd9aa18a98ab5.svg";
export { ForwardRef as ReactComponent };